import { useState, useEffect } from "react";
import HttpClient from "../utils/HttpClient";

const Editgalleryproductmodal = ({
  closemodal,
  selectedImage,
  setSelectedImage,
  data,
  updateForm,
  setData,
  selectedIndex,
  setIsUpdate,
}) => {
  const [title, setTitle] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState(selectedImage?.image ?? "");
  const [loading, setLoading] = useState(false);
  const [imageError, setImageError] = useState("");

  useEffect(() => {
    if (selectedImage) {
      setTitle(selectedImage.title || "");
      setShortDesc(selectedImage.shortDesc || "");
      setUrl(selectedImage.image || "");
    }
  }, [selectedImage]);

  const handleDeleteImage = (id) => {
    setData((prevData) => ({
      ...prevData,
      gallery: prevData.gallery.filter(
        (item, index) => index !== selectedIndex
      ),
    }));
    closemodal();
  }

  const handleUploadPic = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Validate file type
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(selectedFile.type)) {
        setImageError("Error: Please upload a valid image file (PNG/JPEG)");
        return;
      }

      // Validate file size (5MB = 5242880 bytes)
      const maxSize = 5 * 1024 * 1024;
      if (selectedFile.size > maxSize) {
        setImageError("Error: File size must be less than or equal to 5MB");
        return;
      }

      const fileURL = URL.createObjectURL(selectedFile);
      setFile(selectedFile);
      setUrl(fileURL);
    }
    setLoading(true);
    setImageError("");

    try {
      if (file) {
        const formData = new FormData();
        formData.append("image", file);
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res.status) {
          setUrl(res?.data?.url);
        } else {
          setImageError(res?.message || "Error while uploading image");
          console.error("Error while uploading image");
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setImageError(error.message || "Upload failed");
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const submit = async () => {
    // return
    if (selectedImage) {
      // Update the gallery item in data
      setData((prevData) => ({
        ...prevData,
        gallery: prevData.gallery.map((item, index) =>
          // item._id === selectedImage._id ||
          index === selectedIndex
            ? {
              ...item,
              title: title,
              shortDesc: shortDesc,
              image: url,
            }
            : item
        ),
      }));


      setIsUpdate(true)
      closemodal(); // Close modal after save
    }
  };

  return (
    <div className="edittamodalboixshadow">
      <div className="editramoffahsgaellrttdivshhafb">
        <div className="editabannerideletcrrsdivhjdsj">
          <div className="diesdrddeytecroosdivffzl">
            <div className="crossdivicon" onClick={closemodal}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div>
            <p className="edittsbannerttxtppp">Update Image</p>
          </div>
        </div>

        <div className="galleytyusysdheheiighgsccgyyukj">
          <div className="hahgetytsiimghbmaindibv">
            {loading ? (
              <div className="loader-container">
                <div
                  className="loader "
                  style={{
                    position: "absolute",
                    top: " 50%",
                    left: "50%",
                  }}
                ></div>
              </div>
            ) : (
              <>
                <i className="fa-solid fa-trash delete-icon"
                  onClick={() => handleDeleteImage(selectedImage?._id)}
                  style={{
                    cursor: "pointer",
                    color: "white",
                    position: "absolute",
                    right: "10px",
                    marginTop: "10px",
                    padding: "10px",
                    background: "grey",
                    borderRadius: "50%",
                  }}
                ></i>

                <img src={url} alt="Selected" />
                <button className="bggsttgaggsllerybanutn cursor-pointer">
                  Browse File
                  <input
                    type="file"
                    className="ijnbnsdkpwggartyiomghghs cursor-pointer"
                    onChange={handleUploadPic}
                    aria-label="Upload new image"
                    accept="image/*"
                    disabled={loading} // Disable file input while loading
                  />
                </button>
              </>
            )}
            {imageError && <p className="error">{imageError}</p>}
          </div>

          <div className="hhsjjhahhahuyguuydibbanmnib">
            <div className="hhsjjhahhahuyguuy">
              <p className="galrrttxtittxttxtpp">Title</p>
              <input
                value={title}
                type="text"
                className="insttsbtrxrrds"
                onChange={(e) => setTitle(e.target.value)}
                aria-label="Image title"
                disabled={loading} // Disable input while loading
              />
            </div>

            <div className="hhsjjhahhahuyguuy">
              <p className="galrrttxtittxttxtpp">Description</p>
              <textarea
                value={shortDesc}
                rows={4}
                className="insttsbtrxrrdstexrare"
                onChange={(e) => setShortDesc(e.target.value)}
                aria-label="Image description"
                disabled={loading} // Disable textarea while loading
              />
            </div>

            <div className="svavtatvvbtnnmdivmaokin">
              <button
                className="svavtatvvbtnnm"
                disabled={loading}
                onClick={submit}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Editgalleryproductmodal;
